
import { Action, ActionCreator } from 'redux';
import {TableRow,Field,FieldValue,LoadedState} from './types';


// Async actions
export function fetchRow(b_o: string, token: string)  {
  return (dispatch: ((action: Actions) => any),getState: any,apiUrl: string) => {
    dispatch(fetchRowRequest(b_o, token));

    return fetchUtil({
      url: apiUrl + "/bo/" + b_o + "/rows/"+token,
      method: 'GET',
      dispatch: dispatch,
      onSuccess: response => fetchRowSuccess(response as FetchRowSuccessResponse),
      onFailure: response => fetchRowFailure(response)
    });

  };
};

export function fetchNewRow(b_o: string, token: string)  {
  return (dispatch: ((action: Actions) => any),getState: any,apiUrl: string) => {
    dispatch(fetchNewRowRequest(b_o, token));

    return fetchUtil({
      url: apiUrl + "/bo/" + b_o + "/rows/new/"+token,
      method: 'GET',
      dispatch: dispatch,
      onSuccess: response => fetchNewRowSuccess(response as FetchRowSuccessResponse),
      onFailure: response => fetchNewRowFailure(response)
    });

  };
};

export function save(changes: TableRow)  {
  return (dispatch: ((action: Actions) => any),getState: () => LoadedState,apiUrl: string) => {
    const {b_o, token, isNewRow} = getState();
    dispatch(saveRequest());

    return fetchUtil({
      url: apiUrl + "/bo/" + b_o + (isNewRow ? "/rows/new/" : "/rows/" )+token,
      method: 'POST',
      dispatch: dispatch,
      onSuccess: response => saveSuccess(response as SuccessApiResponse,changes),
      onFailure: response => saveFailure(response),
      postContent: {changes: changes}
    });
  };
};


const fetchUtil = (params: FetchUtilParams) => {
  const fetchParams = params.postContent ?
    {
      method: params.method,
      headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
      },
      body: JSON.stringify(params.postContent)
    } :
    {
      method: params.method
    };

  return fetch(params.url,fetchParams)
  .then(response => {
    if(!response.ok) {
      params.dispatch(params.onFailure("Network error"));
      return; 
    }
    response.json().then(response => {
      if(response.status === "ok") {
        params.dispatch(params.onSuccess(response));  
      }else {
        params.dispatch(params.onFailure(response as FailureApiResponse));  
      }
    });
    
  }).catch(error => params.dispatch(saveFailure(error.message)))
};

interface FetchUtilParams {
  url: string,
  method: 'POST' | 'GET',
  dispatch: ((action: Actions) => any),
  onSuccess: ((response: any) => Actions),
  onFailure : ((response:FailureResponse) => Actions),
  postContent?: any
}
export const fetchRowRequest : ActionCreator<FetchRowRequestAction> = (b_o: string, token: string) => ({
  type: 'FETCH_ROW_REQUEST',
  payload: {
	b_o: b_o,
    token: token
  },
});

export const fetchRowSuccess : ActionCreator<FetchRowSuccessAction> = (response: FetchRowSuccessResponse) => ({
  type: 'FETCH_ROW_SUCCESS',
  payload: response
});

export const fetchRowFailure : ActionCreator<FetchRowFailureAction> = (response: FailureResponse) => ({
  type: 'FETCH_ROW_FAILURE',
  payload: response,
});

export const fetchNewRowRequest : ActionCreator<FetchNewRowRequestAction> = (b_o: string, token: string) => ({
  type: 'FETCH_NEW_ROW_REQUEST',
  payload: {
    b_o: b_o,
    token: token
  },
});

export const fetchNewRowSuccess : ActionCreator<FetchNewRowSuccessAction> = (response: FetchRowSuccessResponse) => ({
  type: 'FETCH_NEW_ROW_SUCCESS',
  payload: response
});

export const fetchNewRowFailure : ActionCreator<FetchNewRowFailureAction> = (response: FailureResponse) => ({
  type: 'FETCH_NEW_ROW_FAILURE',
  payload: response,
});

export const saveRequest : ActionCreator<SaveRequestAction> = () => ({
  type: 'SAVE_REQUEST',
  payload: {},
});

export const saveSuccess : ActionCreator<SaveSuccessAction> = (response: SuccessApiResponse,changes: TableRow) => {
  return {
    type: 'SAVE_SUCCESS',
    payload: {response: response,changes: changes},
  };
};

export const saveFailure : ActionCreator<SaveFailureAction> = (response: FailureResponse) => ({
  type: 'SAVE_FAILURE',
  payload: response,
});

export const ackSaveResult : ActionCreator<AckSaveResultAction> = () => ({
  type: 'ACK_SAVE_RESULT',
  payload: {},
});

export const changeFieldValue : ActionCreator<ChangeFieldValueAction> = (fieldId: string,value: FieldValue) => ({
  type: 'CHANGE_FIELD_VALUE',
  payload: {
    fieldId: fieldId,
    value: value
  },
});



export interface FetchRowRequestAction extends Action {
  type: 'FETCH_ROW_REQUEST';
  payload: {
	b_o: string,
    token: string;
  };
}

export interface FetchRowSuccessAction extends Action {
  type: 'FETCH_ROW_SUCCESS';
  payload: FetchRowSuccessResponse;
}

export interface FetchRowFailureAction extends Action {
  type: 'FETCH_ROW_FAILURE';
  payload: FailureResponse;
}


export interface FetchNewRowRequestAction extends Action {
  type: 'FETCH_NEW_ROW_REQUEST';
  payload: {
	b_o: string,
    token: string;
  };
}

export interface FetchNewRowSuccessAction extends Action {
  type: 'FETCH_NEW_ROW_SUCCESS';
  payload: FetchRowSuccessResponse;
}

export interface FetchNewRowFailureAction extends Action {
  type: 'FETCH_NEW_ROW_FAILURE';
  payload: FailureResponse;
}


export interface ChangeFieldValueAction extends Action {
  type: 'CHANGE_FIELD_VALUE';
  payload: {
    fieldId: string;
    value: FieldValue;
  }
}

export interface SaveRequestAction extends Action {
  type: 'SAVE_REQUEST';
  payload: {}
}

export interface SaveSuccessAction extends Action {
  type: 'SAVE_SUCCESS',
  payload: {response: SuccessApiResponse,changes: TableRow},
}

export interface SaveFailureAction extends Action {
  type: 'SAVE_FAILURE';
  payload: FailureResponse;
}

export interface AckSaveResultAction extends Action {
  type: 'ACK_SAVE_RESULT';
  payload: {};
}

export type Actions = FetchRowRequestAction | FetchRowSuccessAction | FetchRowFailureAction | 
  FetchNewRowRequestAction | FetchNewRowSuccessAction | FetchNewRowFailureAction | 
  ChangeFieldValueAction | SaveRequestAction | SaveSuccessAction | SaveFailureAction |
  AckSaveResultAction;


export interface FetchRowSuccessResponse extends SuccessApiResponse {
	fields: Array<Field>;
	tableRow: TableRow;
  tableName: string;
  cssUid: null | string;
}

export interface SuccessApiResponse {
  status: 'ok';
  tableRow: TableRow;
}

export type FailureResponse = FailureApiResponse | string;

export interface FailureApiResponse {
	status: string;
	errorCode: string;
	errorMsg: string;
}








// WEBPACK FOOTER //
// ./src/store/actions.ts